<mono-common-mobile-register-sign-in-bar [signInLinkPath]="signInLinkPath" [registrationLinkPath]="registrationLinkPath" [language]="language"></mono-common-mobile-register-sign-in-bar>
